import { useParams } from 'react-router-dom';

// Prefixo das rotas do tenant: /:cnpj/:filial
export default function useRotaBase() {
  const { cnpj, filial } = useParams();

  return `/${cnpj}/${encodeURIComponent(filial || 'MATRIZ')}`;
}
